import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';

export const CannotApprovedModal = ({
  openDialog,
  handleConfirmAction,
  cancelButtonId,
  confirmButtonId,
}: {
  openDialog: boolean;
  handleConfirmAction: any;
  cancelButtonId?: string;
  confirmButtonId?: string;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <GenericDialog
        open={openDialog}
        maxWidth="sm"
        dialogTitleProps={{
          text: t('placement.placementMods.cannotBeApproved'),
        }}
        dialogActions={[
          {
            id: confirmButtonId,
            text: t('cancelModal.confirmation.OK'),
            onClick: handleConfirmAction,
            variant: 'contained',
          },
        ]}
      >
        {t('placement.placementMods.cannotApprovedMessage')}
      </GenericDialog>
    </>
  );
};
